import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import Timestamp from '../../../Timestamp';
import ExcerptRenderer from '../../../TextRenderer/ExcerptRenderer';
import { getCoverImageAttributes } from '../../Thumb/helpers';
import { styleFromWidthHeight, TextDumboType, getTextDumboTypeBySize, getDeviationTitle } from '../../_helpers';
import s from './Journal.scss';
const JournalDumbView = ({ deviation, className, useTextlessMode, width, height, responsive = true, 'aria-hidden': ariaHidden })=>{
    const { t } = useTranslation();
    // we need to show image background on full height for Micro and Nano thumbs
    const type = getTextDumboTypeBySize(height || width);
    const isMicroOrNano = [
        TextDumboType.MICRO,
        TextDumboType.NANO
    ].includes(type);
    const isWayTooTinyForAnySense = type === TextDumboType.ANTFART;
    const coverImageAttributes = getCoverImageAttributes({
        deviation,
        width,
        height
    });
    const style = styleFromWidthHeight({
        width,
        height
    }, responsive);
    const rootStyle = isMicroOrNano && coverImageAttributes ? _object_spread({}, style, coverImageAttributes.style) : style;
    const headerAttributes = !isMicroOrNano && !isWayTooTinyForAnySense ? coverImageAttributes : {};
    return /*#__PURE__*/ React.createElement(Section, {
        className: classnames(s['root'], s[type], useTextlessMode && s['default-bg'], className),
        style: rootStyle,
        "aria-hidden": ariaHidden
    }, !useTextlessMode && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", _object_spread({
        className: s['header']
    }, headerAttributes), /*#__PURE__*/ React.createElement(Heading, {
        className: s['title']
    }, !deviation.isPublished && /*#__PURE__*/ React.createElement("div", {
        className: s['draft']
    }, t('writer.status.draft')), getDeviationTitle(deviation))), /*#__PURE__*/ React.createElement("div", {
        className: s['body']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['date']
    }, /*#__PURE__*/ React.createElement(Timestamp, {
        timestamp: deviation.publishedTime
    })), /*#__PURE__*/ React.createElement(ExcerptRenderer, {
        className: s['text'],
        textContent: deviation.textContent,
        htmlExcerptLegacy: true
    }))));
};
JournalDumbView.displayName = 'JournalDumbView';
export default JournalDumbView;

//# sourceMappingURL=Journal.js.map